import { z } from 'zod';

export interface IIqTableRateRecentSearchStateService {}
export const RecentSearchEmptyTitle = 'Welcome to iQ RateView';
export const RecentSearchEmptyMessage =
    'Enter an origin, destination, and equipment type to get started. Next time you log in, your recent searches will show up here.';

export const SearchSchema = z.object({
    origin: z.string(),
    destination: z.string(),
    equipment: z.string(),
    date: z.string(),
    timestamp: z.string(),
    query: z.object({
        id: z.string(),
        type: z.string(),
        equipmentType: z.string(),
        origin: z.string(),
        destination: z.string(),
    }),
});

export type Search = z.infer<typeof SearchSchema>;
